const ItemTypeEnum = {
    Item: 0,
    Head: 1,
    Neck: 2,
    Shoulder: 3,
    Shirt: 4,
    Chest: 5,
    Waist: 6,
    Legs: 7,
    Boots: 8,
    Wrist: 9,
    Hands: 10,
    Ring: 11,
    Trinket: 12,
    OneHand: 13,
    OffHand: 14,
    Bow: 15,
    Cloak: 16,
    TwoHand: 17,
    Container: 18,
    Tabard: 19,
    MainHand: 21,
    HeldInOffHand: 23,
    Ammo: 24,
    Thrown: 25,
    Crossbow: 26,
    Relic: 28
}

// ModelViewer slot mapping
const SLOT_MAP = new Map([
  ['head', 1],
  ['neck', 2],
  ['shoulders', 3],
  ['shirt', 4],
  ['chest', 5],
  ['waist', 6],
  ['legs', 7],
  ['feet', 8],
  ['wrists', 9], ['wrist', 9],
  ['hands', 10], ['hand', 10],
  ['finger 1', 11], ['ring 1', 11], ['finger1', 11],
  ['finger 2', 12], ['ring 2', 12], ['finger2', 12],
  ['trinket 1', 13], ['trinket1', 13],
  ['trinket 2', 14], ['trinket2', 14],
  ['back', 15], ['cloak', 15],
  ['main hand', 21], ['main-hand', 21], ['mh', 21],
  ['off hand', 22], ['off-hand', 22], ['oh', 22],
  ['ranged', 18], ['relic', 18],
  ['tabard', 19],
]);

function ItemTypeEnumToString(value) {
    for (let key in ItemTypeEnum) {
        if (ItemTypeEnum[key] === value) {
            return key;
        }
    }

    return "Unknown";
}

module.exports = { ItemTypeEnum, ItemTypeEnumToString, SLOT_MAP };